export const storageUtils = {
  set(key: string, value: any): void {
    try {
      const serialized = JSON.stringify(value);
      localStorage.setItem(key, serialized);
    } catch (error) {
      console.error('Error saving to localStorage:', error);
      throw error;
    }
  },

  get<T = any>(key: string): T | null {
    try {
      const item = localStorage.getItem(key);
      if (item === null) {
        return null;
      }
      return JSON.parse(item) as T;
    } catch (error) {
      console.error('Error reading from localStorage:', error);
      return null;
    }
  },

  remove(key: string): void {
    localStorage.removeItem(key);
  },

  clear(): void {
    localStorage.clear();
  },

  has(key: string): boolean {
    return localStorage.getItem(key) !== null;
  },

  getAllKeys(): string[] {
    return Object.keys(localStorage);
  },

  getSize(): number {
    let total = 0;
    for (const key in localStorage) {
      if (localStorage.hasOwnProperty(key)) {
        const value = localStorage.getItem(key);
        if (value) {
          total += key.length + value.length;
        }
      }
    }
    return total * 2; // UTF-16 uses 2 bytes per character
  }
};

if (typeof window !== 'undefined') {
  (window as any).storageUtils = storageUtils;
}
